import React from 'react'
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom'
import { Routes as BillingRoutes } from './billing'
import { Routes as BoatRoutes } from './boats'
import { Routes as MembershipCardRoutes } from './membership_card'
import { Routes as GatedContent } from './gated_content'
import { Routes as RenewalRoutes, Layout as RenewalLayout } from './renewal'
import { Routes as UpgradeRoutes } from './upgrades'
import * as Views from './views'
import {
  MarketingCodeProvider,
  StripePaymentIntentReset,
} from 'member-portal/components'
import {
  MembershipProvider,
  MemberApplicationReset,
} from './components'
import { PATH, makePath } from 'config'
import { legacyPathRedirect } from 'utils'

const propTypes = {}

// --[Memberships Routes]---------------------------------------------------------------
// All of the "memberships" routes require that the membership data for an 
// account (which can have *multiple* memberships) be available in the Redux 
// store ("allMemberships").
//
// Membership-specific views, like MembershipCard and Billing, require the data 
// for a *specific* membership be available in the Redux store ("membership"). 
// The MembershipProvider obtains the specific membership data from
// "allMemberships" (fetched by the AllMembershipsProvider called in 
// MemberAccountProvider) and stores it in Redux.

function Routes() {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route exact path={makePath(path, PATH.ROOT)}>
        <Views.MembershipLanding />
      </Route>
      <Route path={makePath(path, PATH.SELECT_YOUR_MEMBERSHIP)}>
        <SelectYourMembershipRoutes />
      </Route>
      <Route path={makePath(path, PATH.GATED_CONTENT)}>
        <GatedContent />
      </Route>
      <Route
        path={makePath(path, legacyPathRedirect.PATH.SELECT_YOUR_MEMBERSHIP)}
        render={({ location }) => (
          <Redirect
            to={{
              ...location,
              pathname: legacyPathRedirect.resolvePathname(location.pathname),
            }}
          />
        )}
      />
      <Route path={makePath(path, PATH.SFID)}>
        <MembershipProvider>
          <MembershipRoutes />
        </MembershipProvider>
      </Route>
    </Switch>
  )
}

Routes.propTypes = propTypes

export default Routes

function MembershipRoutes() {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={makePath(path, PATH.BILLING)}>
        <BillingRoutes />
      </Route>
      <Route path={makePath(path, PATH.BOATS)}>
        <BoatRoutes />
      </Route>
      <Route path={makePath(path, PATH.MEMBERSHIP_CARD)}>
        <MembershipCardRoutes />
      </Route>
      <Route path={makePath(path, PATH.RENEW_MEMBERSHIP)}>
        <RenewalRoutes />
      </Route>
      <Route path={makePath(path, PATH.UPGRADES)}>
        <UpgradeRoutes />
      </Route>
    </Switch>
  )
}

function SelectYourMembershipRoutes() {
  const { path } = useRouteMatch()

  return (
    <MemberApplicationReset>
      <StripePaymentIntentReset>
        <Switch>
          <Route exact path={makePath(path, PATH.RENEW_MEMBERSHIP)}>
            <MarketingCodeProvider isRenewal>
              <RenewalLayout>
                <Views.RenewalSelectYourMembership />
              </RenewalLayout>
            </MarketingCodeProvider>
          </Route>
          <Route exact path={makePath(path, PATH.UPGRADES, PATH.MEMBERSHIP)}>
            <Views.MembershipUpgradesSelectYourMembership />
          </Route>
          <Route exact path={makePath(path, PATH.UPGRADES, PATH.TRAILER_CARE)}>
            <Views.TrailerCareUpgradesSelectYourMembership />
          </Route>
        </Switch>
      </StripePaymentIntentReset>
    </MemberApplicationReset>
  )
}
